import { createFileRoute } from "@tanstack/react-router";

import { EnterCode } from "@/views/login/enter-code";

export const Route = createFileRoute("/_guest/enter-code")({
  component: EnterCode,
});
